import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface IssueBannerInput {
  kind: 'WrongBasket' | 'OrphanStock';
  medicationName?: string;
  medicationId?: string;
  scannedProductId: string;
  expectedBasket?: number;
  expectedPatient?: string;
}

@Component({
  selector: 'app-issue-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './issue-banner.component.html',
  styleUrl: './issue-banner.component.css',
})
export class IssueBannerComponent {
  @Input({ required: true }) issue!: IssueBannerInput;
  @Output() moveNow = new EventEmitter<void>();
  @Output() defer   = new EventEmitter<void>();
  @Output() dismiss = new EventEmitter<void>();
}
